import { useQuery } from "@tanstack/react-query";
import booksService from "@/features/books/services/booksService";
import DURATIONS from "@/shared/constants/durations";
import { booksKeys } from "./booksQueryKeys";

export function useArchivedBookCount() {
    return useQuery<number, Error>({
        gcTime: DURATIONS.FIVE_MINUTES,
        queryFn: () => booksService.getArchivedBookCount(),
        queryKey: booksKeys.archivedCount(),
        staleTime: DURATIONS.ONE_MINUTE,
    });
}
